import {
    FETCH_BARRAGECONFIGS,
    FETCH_BARRAGEMESSAGE
} from '../actions/barrage';


export const initialState = {
    isFetching: true,
    data: null
};

export const barrageConfigs = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_BARRAGECONFIGS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_BARRAGECONFIGS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const barrageMessage = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_BARRAGEMESSAGE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_BARRAGEMESSAGE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/redux/reducers/barrage.js